import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import Dropzone from "react-dropzone";
import {
  DocCancelIcon,
  DocUploadedIcon,
  DocUploadIcon,
  DownloadSampleIcon,
  ViewIcon,
} from "../../../../../utility/constants/assetsManager";
import ResizeListner from "../../../../../utility/ResizeListner";
import { CustomButton } from "../../../../components/main_comps/custom_button";
import { saveAs } from "file-saver";
import upiFile from "../../../../../data/samplefiles/BulkUploadUpi.xlsx";
import netFile from "../../../../../data/samplefiles/BulkUploadNetBanking.csv";
import upiCollectFile from "../../../../../data/samplefiles/BulkUploadUpi.xlsx";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import { SS_ROLE, SS_USER_HASH_ID } from "../../../../../utility/constants/secureStorageManager";
import secureStorage from "../../../../../services/secureStorage";

const BulkUploadTab = ({
  passRawData,
  passUploadedData,
  onPreviewData,
  currentTab,
  reset,
  changeReset,
}) => {


  const { width, height } = ResizeListner();
  const [fileName, setFileName] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [showFileName, setShowFileName] = useState(false);
  const [progressWidth, setProgressWidth] = useState(0);

  function getFileExtension(filename) {
    var ext = /^.+\.([^.]+)$/.exec(filename);
    return ext == null ? "" : ext[1];
  }

  const handleDrop = (acceptedFiles) => {
    if (
      getFileExtension(acceptedFiles[0].name) === "csv" ||
      getFileExtension(acceptedFiles[0].name) === "xls" ||
      getFileExtension(acceptedFiles[0].name) === "xlsx" || // 
      getFileExtension(acceptedFiles[0].name) === "xlsv"
    ) {
      if (acceptedFiles && acceptedFiles.length <= 1) {
        setFileName(acceptedFiles.map((file) => file.name));
        setShowFileName(true);
        const reader = new FileReader();
        reader.onload = () => {
          if (acceptedFiles) {
            passRawData(acceptedFiles);
            Papa.parse(acceptedFiles[0], {
              complete: function (results) {
                console.log(results, "results____meee");
                // arrayModifier(results.data);
              },
            });
          }
        };
        handleFileUpload(acceptedFiles[0]);
        reader.readAsBinaryString(acceptedFiles[0]);
      } else {
        enqueueSnackbar("Select only one file to upload", {
          variant: "error",
        });
      }
    } else {
      enqueueSnackbar("Invalid file type , please select csv ,xls or xlsv", {
        variant: "error",
      });
    }
  };

  let checkHeaders = [];

  if (currentTab === 1) {
    checkHeaders = ["upi", "phone", "email", "name", "amount"];
  } else {
    checkHeaders = [
      "upiid",
      "customername",
      "amount",
      "customermobileno",
      "remark",
    ];
  }
  const headerChecker = (data = []) => {
    return (
      data &&
      data.every((vals, index) => {
        let str = vals?.toString()?.toLowerCase().replace(/\s/g, "");
        if (index <= 7) {
          if (str === "id" || str === "remarks") return true;
          else return checkHeaders?.includes(str);
        }
      })
    );
  };
  const processData = (dataString) => {
    const dataStringLines = dataString.split(/\r\n|\n/);
    if (dataStringLines) {
      let headers = [];
      let index = 0;

      let datas1 = dataStringLines[0]?.split(",");

      if (
        headerChecker(datas1?.includes("id") ? datas1?.slice(1, 8) : datas1) ||
        headerChecker(dataStringLines[1]?.split(","))
      ) {
        if (
          headerChecker(datas1?.includes("id") ? datas1?.slice(1, 8) : datas1)
        ) {
          index = 0;
          headers = dataStringLines[0]?.split(
            /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
          );

          if (currentTab === 1) {
            headers = ["upi", "phone", "email", "name", "amount"];
          } else {
            headers = [
              "upiId",
              "customerName",
              "amount",
              "customerMobileNo",
              "remark",
            ];
          }
        } else if (headerChecker(dataStringLines[1]?.split(","))) {
          index = 1;
          headers = dataStringLines[1]?.split(
            /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
          );
        }

        setShowFileName(true);
        const list = [];

        for (let i = index + 1; i < dataStringLines?.length; i++) {
          let row = [];
          if (datas1.includes("id")) {
            row = dataStringLines[i]
              ?.split(/,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/)
              ?.slice(1, 8);
          } else {
            row = dataStringLines[i]?.split(
              /,(?![^"]*"(?:(?:[^"]*"){2})*[^"]*$)/
            );
          }

          if (headers && row?.length == headers?.length) {
            const obj = {};
            for (let j = 0; j < headers?.length; j++) {
              let d = row[j];
              if (d?.length > 0) {
                if (d[0] == '"') d = d?.substring(1, d?.length - 1);
                if (d[d.length - 1] == '"') d = d?.substring(d?.length - 2, 1);
              }
              if (headers[j]) {
                obj[headers[j].toLowerCase()] = d;
              }
            }

            if (Object.values(obj).filter((x) => x).length > 0) {
              list.push(obj);
            }
          }
        }
        if (list.length > 0) {
          passUploadedData(list.length > 0 && list);
        } else {
          setShowFileName(false);
          enqueueSnackbar("File  doesn't contain a valid datas", {
            variant: "error",
          });
        }
      } else {
        setShowFileName(false);
        enqueueSnackbar(
          "File  doesn't contain proper headers, use the file mentioned in below sample template",
          {
            variant: "error",
          }
        );
      }
    } else {
      setShowFileName(false);
      enqueueSnackbar("Invalid data provided", {
        variant: "error",
      });
    }
  };


  // const ss_id = secureStorage.getItem(SS_USER_HASH_ID);
  // const role = secureStorage.getItem(SS_ROLE);
  // role === CLIENT ? ss_id : ""
  // client_secret: role === CLIENT ? ss_id : "",



  // const sendTransferRequest = async (data) => {
  //   console.log(data, "data_____");
  //   const config = {
  //     method: 'post',
  //     maxBodyLength: Infinity,
  //     url: API_ENDPOINT.core_url + 'client/bulk/direct-transfer',
  //     headers: {
  //       // 'client_secret': role === CLIENT ? ss_id : "",
  //       'client_secret': 'f50009cb-c8b5-4969-ab73-b99a01cf45fd',
  //       'program_id': '7f8d61d2-d27d-47e5-aef2-478f72e494ba',
  //       'Content-Type': 'application/json'
  //     },
  //     data: JSON.stringify(data)
  //   };

  //   try {
  //     const response = await axios.request(config);
  //     console.log('API Response:', response.data);
  //     enqueueSnackbar("Transfer successful", { variant: "success" });
  //   } catch (error) {
  //     console.error('API Error:', error);
  //     enqueueSnackbar("Error during transfer", { variant: "error" });
  //   }
  // };

  const handleFileUpload = (e) => {
    console.log(e, "file");
    if (e) {
      const file = e;
      const reader = new FileReader();
      reader.onload = (evt) => {
        const bstr = evt.target.result;
        const wb = XLSX.read(bstr, { type: "binary" });
        const wsname = wb.SheetNames[0];
        const ws = wb.Sheets[wsname];
        const data = XLSX.utils.sheet_to_json(ws);

        data.forEach((row) => {
          console.log(row, "row_____123");
        });
        passUploadedData(data);

        // Transform data to API format



        // Call the API
        // sendTransferRequest(payload);
      };
      reader.readAsBinaryString(file);
    }
  };



  const saveFile = () => {
    currentTab === 1
      ? saveAs(upiFile, "BulkUploadUpi.xlsx")
      : saveAs(upiCollectFile, "BulkPayout.xlsx");
  };

  useEffect(() => {
    if (reset) {
      setFileName("");
      setShowFileName(false);
      changeReset();
    }
  }, [reset]);
  return (
    <div
      style={{
        width: "100%",
        padding: 20,
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        paddingBottom: 0,
        justifyContent: "space-between",
        height: height * 0.5,
      }}
    >
      {showFileName ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 15,
          }}
        >
          <DocUploadedIcon style={{ width: "24px", height: "24px" }} />
          <p>{fileName}</p>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 5,
              marginLeft: "40px",
            }}
          >
            <ViewIcon
              style={{ width: "24px", height: "24px", cursor: "pointer" }}
              onClick={() => onPreviewData(1)}
            />
            <DocCancelIcon
              style={{ width: "24px", height: "24px", cursor: "pointer" }}
              onClick={() => {
                setShowFileName(false);
                setFileName("");
              }}
            />
          </div>
        </div>
      ) : (
        <div>
          <Dropzone onDrop={handleDrop} acceptedFiles={[".csv", ".xlsx", ".xlsx"]}>
            {({
              getRootProps,
              getInputProps,
              isDragActive,
              isDragAccept,
              isDragReject,
            }) => {
              const additionalClass = isDragAccept
                ? "accept"
                : isDragReject
                  ? "reject"
                  : "";

              return (
                <div
                  style={{
                    borderStyle: "dashed",
                    height: width > 600 ? 250 : 300,
                    borderWidth: "1px",
                    borderStroke: "1px",
                    borderColor: "#38369C",
                    borderRadius: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                  }}
                  {...getRootProps({
                    className: `dropzone ${additionalClass}`,
                  })}
                >
                  <DocUploadIcon style={{ width: 24, height: 24 }} />
                  <p
                    style={{
                      color: "#7E7E7E",
                      fontSize: 18,
                      padding: 0,
                      margin: 0,
                      fontWeight: "500",
                      marginTop: "10px",
                    }}
                  >
                    Drag and drop files here to upload
                  </p>

                  <div style={{ marginTop: "20px" }}>
                    <label
                      htmlFor="file-upload"
                      className="custom-file-upload"
                      style={{
                        borderRadius: 7,
                        padding: "10px 20px 10px 20px",
                        fontSize: 14,
                        fontWeight: "bold",
                        backgroundColor: "#38369C",
                        color: "white",
                        fontWeight: "500",
                      }}
                    >
                      Choose File
                    </label>
                  </div>
                </div>
              );
            }}
          </Dropzone>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              width: "100%",
              marginTop: "10px",
              gap: 10,
            }}
          >
            <DownloadSampleIcon style={{ width: 20, height: 20 }} />
            <p
              style={{
                fontSize: 15,
                textDecoration: "underline",
                color: "#38369C",
                cursor: "pointer",
              }}
              onClick={() => saveFile()}
            >
              {currentTab === 1
                ? "Download UPI template(.xlsx)"
                : "Download Bulk Payout Template(.xlsx)"}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default BulkUploadTab;
